import React from 'react';
import {Divider, Stack} from '@mui/material';
import SourcesSectionContent from './SourcesSectionContent';
import SourcesSectionSearchHeader from './SourcesSectionSearchHeader';
import SourcesUploadQueue from './SourcesUploadQueue';
import SourcesSectionDialogs from './SourcesSectionDialogs';
import useSourcesSectionController from './useSourcesSectionController';

/**
 * Sources panel. Renders one of two surfaces depending on `mode`:
 *  - `search`: federated cross-source search (header with scope/mode toggles + filters,
 *    AI summary, and ranked results). The file browser is hidden.
 *  - `files`:  the file manager only (folder/file browser, upload, bulk actions). No search
 *    header, no filters, no search box.
 *
 * @param {{isActive?: boolean, mode?: 'search'|'files'}} props
 */
const SourcesSection = ({isActive, mode = 'search'}) => {
    const {
        searchHeaderProps,
        contentProps,
        uploadQueueProps,
        dialogProps,
    } = useSourcesSectionController({isActive, mode});

    const isSearch = mode === 'search';

    return (
        <Stack height="100%">
            {isSearch && (
                <>
                    <SourcesSectionSearchHeader {...searchHeaderProps} />
                    <Divider/>
                </>
            )}

            <SourcesSectionContent {...contentProps} />

            <SourcesUploadQueue {...uploadQueueProps} />

            <SourcesSectionDialogs {...dialogProps} />
        </Stack>
    );
};

export default React.memo(SourcesSection);
